
import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { actions } from "@gsd/redux-store-backoffice";
import type { Dispatch } from "redux";

const {
  account: {
    creators: { logout }
  }
} = actions;

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    logout: () => dispatch(logout())
  };
};
type LogoutComponentProps = ReturnType<typeof mapDispatchToProps>;
class LogoutComponent extends React.Component<LogoutComponentProps> {
  componentDidMount() {
    this.props.logout();
  }

  render() {
    return <Redirect to="/" />;
  }
}
export default connect(
  null,
  mapDispatchToProps
)(LogoutComponent);
